export enum ImplementationTypeEnum {
  PSC = 'PSC',
  JOC = 'JOC',
  FORMAL_BID = 'Formal Bid',
}
